import { union } from "lodash";

import { KeyMap } from "utils/interface";

import { IMacro } from "../macros/interfaces";
import { IMessageBasedAction, IRule, IRuleAction } from "../rules/interfaces";

import { ICannedResponse } from "./interfaces";

export const caseInsensitiveCompare = (a: string, b: string): number => a.toLowerCase().localeCompare(b.toLowerCase());

export function removeIdFromIdsByShortcuts(base: KeyMap<string[]>, id: string): KeyMap<string[]> {
  return Object.keys(base).reduce((acc, shortcut) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    acc[shortcut] = base[shortcut].filter(i => i !== id);

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (acc[shortcut].length === 0) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      delete acc[shortcut];
    }

    return acc;
  }, {});
}

export function mergeIdsByShortcuts(base: KeyMap<string[]>, cannedResponse: ICannedResponse): KeyMap<string[]> {
  // Update idsByShortcuts for new list of shortcuts
  const mergedEntries = cannedResponse.shortcuts.reduce((acc, shortcut) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    acc[shortcut] = union(base[shortcut] || [], [cannedResponse.id]);
    return acc;
  }, {});

  // Remove id from remaining idsByShortcuts
  const entriesCopy = { ...base };
  cannedResponse.shortcuts.forEach(shortcut => {
    delete entriesCopy[shortcut];
  });
  const filteredEntries = removeIdFromIdsByShortcuts(entriesCopy, cannedResponse.id);

  return {
    ...filteredEntries,
    ...mergedEntries,
  };
}

export function groupCannedResponsesIdsByShortcuts(cannedResponses: ICannedResponse[]): KeyMap<string[]> {
  return cannedResponses.reduce((acc: KeyMap<string[]>, cannedResponse: ICannedResponse) => {
    cannedResponse.shortcuts.forEach(shortcut => {
      acc[shortcut] = (acc[shortcut] || []).concat([cannedResponse.id]);
    });
    return acc;
  }, {});
}

const isMessageBasedAction = (action: IRuleAction): action is IMessageBasedAction =>
  ["message", "sendRatingRequest", "sendFollowUp"].includes(action.type);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const findUsedCannedResponses = <T extends IMacro | IRule>(automations: T[]) => {
  const usedCannedResponses: { [cannedResponseId: string]: T[] } = {};

  automations.forEach(automation => {
    automation.actions.forEach(action => {
      if (isMessageBasedAction(action)) {
        const cannedResponseId = action.cannedResponseID;
        if (cannedResponseId) {
          if (!usedCannedResponses[cannedResponseId]) {
            usedCannedResponses[cannedResponseId] = [];
          }
          usedCannedResponses[cannedResponseId].push(automation);
        }
      }
    });
  });

  return usedCannedResponses;
};

interface IUsageMap {
  [cannedResponseId: string]: { rules: IRule[]; macros: IMacro[]; total: number };
}

export const mapCannedResponsesToUsage = (rules: IRule[], macros: IMacro[]): IUsageMap => {
  const usageInRules = findUsedCannedResponses(rules);
  const usageInMacros = findUsedCannedResponses(macros);
  const result: IUsageMap = {};

  Object.entries(usageInRules).forEach(([id, rulesUsingId]) => {
    result[id] = {
      rules: rulesUsingId,
      macros: usageInMacros[id] || [],
      total: rulesUsingId.length + (usageInMacros[id] || []).length,
    };
  });

  Object.entries(usageInMacros).forEach(([id, macrosUsingId]) => {
    if (!result[id]) {
      result[id] = {
        rules: [],
        macros: macrosUsingId,
        total: macrosUsingId.length,
      };
    }
  });

  return result;
};

export const cannedExists = (cannedResponseId: string, cannedResponses: ICannedResponse[]): boolean => {
  return cannedResponses.some(cannedResponse => cannedResponse.id === cannedResponseId);
};
